/* eslint-disable max-len */
/* eslint-disable */
import {Button} from 'antd';
import React from 'react';

interface WelcomeProps {
  welcomePage: () => void;
}

const WelcomeForm: React.FC<WelcomeProps> = ({welcomePage}) => {
  return (
    <>
      <h2 style={{fontSize: 35, textAlign: 'center'}}>
        Welcome to Bharat Carbon
      </h2>
      <h2
        style={{
          fontSize: 35,
          textAlign: 'center',
          lineHeight: '10px'
        }}
      >
        Platform
      </h2>

      <p
        style={{
          fontSize: 18,
          fontWeight: 500,
          textAlign: 'center',
          padding: '0 90px'
        }}
      >
        Complete your onboarding to move one step closer to tracking and
        managing your emissions!
      </p>

      <div style={{padding: '12px 0'}}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Button
            type="primary"
            style={{
              borderRadius: '6px',
              padding: '6px 24px',
              height: '40px'
            }}
            onClick={welcomePage}
          >
            {"Let's get started!!!"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default WelcomeForm;
